<div class="jw" *ngIf="!hidden">
  <!-- Panel abierto: el chat es <app-agent-panel>, no una segunda implementación. -->
  <div class="jw-panel" *ngIf="open">
    <button
      class="jw-close"
      type="button"
      (click)="toggle()"
      [attr.aria-label]="'common.close' | transloco"
    >
      <i class="pi pi-times"></i>
    </button>
    <app-agent-panel variant="general"></app-agent-panel>
  </div>

  <!-- Globo de saludo, solo hasta el primer uso. -->
  <div class="jw-teaser" *ngIf="!open && showTeaser">
    <button
      class="jw-teaser-x"
      type="button"
      (click)="dismissTeaser($event)"
      [attr.aria-label]="'common.close' | transloco"
    >
      <i class="pi pi-times"></i>
    </button>
    <strong>{{ 'repuestos.agent.widgetTeaserTitle' | transloco }}</strong>
    <span>{{ 'repuestos.agent.widgetTeaserSub' | transloco }}</span>
  </div>

  <button
    class="jw-bubble"
    type="button"
    (click)="toggle()"
    [attr.aria-label]="'repuestos.agent.widgetOpen' | transloco"
  >
    <app-juana-avatar size="xl" [statusDot]="true"></app-juana-avatar>
  </button>
</div>
